export default "__VITE_ASSET__V6UYC1_EFfGnYGLE7Hx52g__"